<template>
  <div class="min-h-screen bg-gray-100 font-live">

    <testmode-ribbon :session="session"></testmode-ribbon>

    <nav class="bg-white top-0 left-0 shadow-sm fixed w-full">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-12 sm:h-16">
          <div class="flex">
            <div class="flex-shrink-0 flex items-center">
              <img class="block sm:hidden h-8 sm:h-10 w-auto sharp-image" src="/img/brandpreneurship-logo.png"
                alt="brandpreneurship" />
              <img class="hidden sm:block h-8 sm:h-10 w-auto sharp-image" src="/img/brandpreneurship-logo.png"
                alt="brandpreneurship" />
            </div>
            <div v-if="false" class="ml-6 flex-col sm:mt-1">
              <p class="text-lg sm:text-xl font-light">
                brandpreneurship
              </p>
              <p class="text-sm">{{ participant.full_name || '' }}</p>
            </div>

          </div>

          <div class="ml-6 flex float-right">
            <span class="ml-3 shadow-sm rounded-md mt-1 md:mt-2">
              <Link :href="route('live.index', { uuid: this.participant.uuid })"
                class="inline-flex items-center px-2 sm:px-4 py-1.5 sm:py-3 border border-transparent text-sm leading-5 font-medium rounded-md text-gray-500 hover:text-white bg-gray-300 hover:bg-gray-400 focus:outline-none focus:shadow-outline-gray focus:border-gray-400 active:bg-gray-400 transition duration-150 ease-in-out">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-4 h-4 text-gray-500">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
              </svg>

              </Link>
            </span>
          </div>
        </div>
      </div>
    </nav>

    <div class="py-1">
      <main>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 pt-12">
          <!-- Main: start -->

          <slot></slot>

          <!-- Main: end -->
        </div>
      </main>
    </div>

  </div>
</template>

<script>
import TestmodeRibbon from '@/Shared/TestmodeRibbon';

export default {
  components: {
    TestmodeRibbon,
  },

  props: ['session', 'participant'],

  mounted() {
    Echo.channel('markencode-app.session.' + this.session.id)
      .listen('.session.phase.updated', (e) => {
        console.log('session.phase.updated');
        // if (e.current_phase != this.session.current_phase) {
        this.$inertia.visit(
          this.route('live.index', { uuid: this.participant.uuid }),
        );
        // }
      })

      // INFO: TOM 2023-04-28: I think we do not need this anymore because
      // session.phase.updated is being fired anyway
      // .listen('.session.archetype.question.finished', (e) => {
      //   console.log('session.archetype.question.finished');

      //   if (
      //     e.current_profile_question != this.session.current_profile_question
      //   ) {
      //     this.$inertia.visit(
      //       this.route('live.index', { uuid: this.participant.uuid })
      //     );
      //   }
      // })
      ;

    window.axios.post(
      this.route('live.here', {
        uuid: this.participant.uuid
      }),
      {}
    );
  },

  destroyed() {
    // console.log('leaving layout component');
    // Echo.leave('markencode-app.session.' + this.session.id);
  },

};
</script>
